import React from "react"
import { Helmet } from "react-helmet"

import type { BreadcrumbSchemaProps } from "../../types/schema"

/**
 * BreadcrumbSchema component for adding BreadcrumbList structured data (JSON-LD)
 * This helps search engines understand site navigation hierarchy and can
 * display breadcrumbs in search results.
 *
 * @see https://schema.org/BreadcrumbList
 * @see https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
 */
export const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({
  items,
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      item: item.url,
      name: item.name,
      position: index + 1,
    })),
  }

  return (
    <Helmet as={React.Fragment as any}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}
